module.exports = __webpack_public_path__ + "static/media/envelope.7c2e60b8.svg";